export const getters = {
  ExpenseitemsRows: state => state.expense_item,
  systemExpenses: state => state.expenses
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/expenses/getters.js